import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "communications_list" }
const _hoisted_2 = {
  key: 0,
  class: "buttons"
}
const _hoisted_3 = { class: "message-list" }
const _hoisted_4 = { class: "text-center" }

import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import {
  ButtonClassic, ButtonPopover, InfiniteLoader, Slider, SliderCard,
} from "@lde/core_lde_vue";
import { UilCommentAlt, UilEye } from "@lde/vue-unicons";

import Communication from "@/components/communications/Communication.ts.vue";
import CommunicationModel from "@/domains/communications/communication";

import { buildPages } from "./pages";

// #endregion

// #region Données et état =======================

export default /*@__PURE__*/_defineComponent({
  __name: 'CommunicationsList.ts',
  setup(__props) {

// #region imports =======================
const messages = ref<CommunicationModel[]>([]);
const { t } = useI18n();
const route = useRoute();
const pages = buildPages();
const autoplay = ref(true);
const messagesAdded = ref<CommunicationModel | null>(null);
const listOpen = ref(false);
const showSlider = ref(true);
// #endregion

// #region Filtrage et affichage des messages =======================
const routesName: Record<string, string> = {};
pages.flat().forEach((page) => {
  [page, ...page.subPages ?? []].forEach((p) => {
    routesName[p.key] = t(p.labelKey);
  });
});

const messageAffiches = computed(() => {
  const pageName = route.name as string;
  return messages.value.filter(
    (message) => message.pages.includes("all") || message.pages.some((page) => pageName?.startsWith(page)),
  );
});
const globalMessages = computed(() => messages.value.filter((message) => message.id !== undefined));

const verbosePages = (message: CommunicationModel) => {
  if (message.pages.includes("all")) {
    return ["Toutes les pages"];
  }
  return message.pages.map((page) => routesName[page] || page);
};
// #endregion

// #region Chargement des messages =======================
onMounted(() => {
  fetchMessages();
});

const reloadSlider = () => {
  showSlider.value = false;
  setTimeout(() => {
    showSlider.value = true;
  }, 250);
};

const fetchMessages = async () => {
  // Hack dégeu: le slider est full bugé quand on retire des éléments à la volée...
  messages.value = await CommunicationModel.fetchAll();
  reloadSlider();
};
// #endregion

// #region Ajout, suppression et édition =======================
const removeMessage = () => {
  fetchMessages();
};

const addMessage = () => {
  messagesAdded.value = new CommunicationModel({
    texte: "", titre: "", couleur: "info", pages: ["all"],
  });
};

const handleNewMessage = () => {
  messagesAdded.value = null;
  fetchMessages();
};

const editingChange = (value: boolean) => {
  autoplay.value = !value;
};
// #endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$store.getters.isMaitreComptaRegion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ButtonPopover), {
            modelValue: listOpen.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((listOpen).value = $event)),
            label: `${globalMessages.value.length}`,
            variant: "solid",
            color: "primary",
            icon: "left",
            placement: "bottom",
            trigger: "click"
          }, {
            "left-icon": _withCtx(() => [
              _createVNode(_unref(UilEye))
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("communications.il-y-a-x-messages-actifs", { count: globalMessages.value.length, })), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalMessages.value, (message, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: message.id ?? index
                    }, [
                      _createTextVNode(" \"" + _toDisplayString(message.titre) + "\" - " + _toDisplayString(_ctx.$moment(message.date_modification || message.date_creation).format(_ctx.$t("global.format-date"))) + ": ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(verbosePages(message), (page) => {
                        return (_openBlock(), _createElementBlock("ul", { key: page }, [
                          _createElementVNode("li", null, _toDisplayString(page), 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label"]),
          _createVNode(_unref(ButtonClassic), {
            label: "Ajouter un message",
            variant: "ghost",
            color: "primary",
            icon: "left",
            onClick: addMessage
          }, {
            "left-icon": _withCtx(() => [
              _createVNode(_unref(UilCommentAlt))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (messagesAdded.value)
      ? (_openBlock(), _createBlock(Communication, {
          key: 1,
          modelValue: messagesAdded.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((messagesAdded).value = $event)),
          onDelete: _cache[2] || (_cache[2] = ($event: any) => (messagesAdded.value = null)),
          onSave: handleNewMessage
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (showSlider.value)
      ? (_openBlock(), _createBlock(_unref(Slider), {
          key: 2,
          autoplay: autoplay.value
        }, {
          "slider-items": _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageAffiches.value, (message, index) => {
              return (_openBlock(), _createBlock(_unref(SliderCard), {
                key: message.id ?? index
              }, {
                custom: _withCtx(() => [
                  _createVNode(Communication, {
                    modelValue: messageAffiches.value[index],
                    "onUpdate:modelValue": ($event: any) => ((messageAffiches.value[index]) = $event),
                    onDelete: _cache[3] || (_cache[3] = ($event: any) => (removeMessage())),
                    onEditing: editingChange
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["autoplay"]))
      : (_openBlock(), _createBlock(_unref(InfiniteLoader), { key: 3 }))
  ]))
}
}

})